import script from "./DasboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./DasboardView.vue?vue&type=script&setup=true&lang=js"

import "./DasboardView.vue?vue&type=style&index=0&id=ac822eea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac822eea"]])

export default __exports__